<template>
    <div id="benefits">
        <b-container fluid class="benefits-title">
            <b-row>
                <b-col md="5">
                    <h3>{{ $t('benefits.title') }}</h3>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid class="benefits-wrapper">
            <b-row> 
                <b-col md="5" class="centerv">
                    <img class="img-fluid" src="../assets/img_beneficio1.png" alt="">
                </b-col>
                <b-col md="7" class="centerv">
                    <h4>{{ $t('benefits.benefitTitle1') }}</h4>
                    <p v-html="$t('benefits.benefitText1')"></p>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid class="benefits-wrapper">
            <b-row>
                <b-col md="5" class="centerv">
                    <img class="img-fluid" src="../assets/img_beneficio2.png" alt="">
                </b-col>
                <b-col md="7" class="centerv">
                    <h4>{{ $t('benefits.benefitTitle2') }}</h4>
                    <p v-html="$t('benefits.benefitText2')"></p>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid class="benefits-wrapper benefits-wrapper-last">
            <b-row>
                <b-col md="5" class="centerv">
                    <img class="img-fluid" src="../assets/img_beneficio3.png" alt="">
                </b-col>
                <b-col md="7" class="centerv">
                    <h4>{{ $t('benefits.benefitTitle3') }}</h4>
                    <p v-html="$t('benefits.benefitText3')"></p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
#benefits{
    padding-top: 100px;
}
.benefits-wrapper{
    border-top: 1px solid #503B2D4D;
    padding: 55px 117px;
}
.benefits-wrapper-last{
    border-bottom: 1px solid #503B2D4D;
}
.benefits-title{
    padding: 0 117px 70px 117px;
}
h3{
    font-weight: 400 !important;
    font-size: 45px;
}
h4{
    font-weight: 400 !important;
    font-size: 30px;
}
p{
    font-weight: 300;
    font-size: 20px;
    line-height: 1.3;
}
@media (max-width: 992px){
    .benefits-wrapper{
        padding: 55px 117px;
    }
    .benefits-title{
        padding: 0 57px 70px 117px;
    }
}
@media (max-width: 768px){
    .benefits-wrapper{
        padding: 55px 35px;
    }
    .benefits-title{
        padding: 0 35px 30px 35px;
    }
    img{
        margin-bottom: 20px;
    }
    h3{
        font-size: 35px;
    }
    p{
        font-size: 18px;
    }
}
</style>